import { render, staticRenderFns } from "./collaboration_page.vue?vue&type=template&id=1911631f&scoped=true&"
import script from "./collaboration_page.vue?vue&type=script&lang=js&"
export * from "./collaboration_page.vue?vue&type=script&lang=js&"
import style0 from "./collaboration_page.vue?vue&type=style&index=0&id=1911631f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1911631f",
  null
  
)

export default component.exports